import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useEffect, useRef } from 'react';
import { LoadingState } from '@atlassian/notification-types/types';
import { triggerNotificationFilterViewed, useCreateFireAnalyticsFromTrigger } from '../../common/utils/analytics';
import { generateFilterStateKey } from '../../common/utils/generate-filter-state-key';
import { useMarkSeenService } from '../../services/use-mark-seen-service';
export var useNotificationsController = function useNotificationsController(currentNotificationList, filters) {
  var firstRequestCompleted = currentNotificationList.firstRequestCompleted,
    fetchData = currentNotificationList.fetchData,
    fetchState = currentNotificationList.fetchState; // don't use currentNotificationList as a direct effect dep

  // Used for screen event analytics - tracking previously seen filter combinations
  var seenCombinations = useRef([]);
  var firstRender = useRef(true);
  var fireNotificationFilterViewed = useCreateFireAnalyticsFromTrigger(triggerNotificationFilterViewed);
  var isfirstFilterView = function isfirstFilterView(filters) {
    var filterIndex = generateFilterStateKey(filters);
    if (!seenCombinations.current.includes(filterIndex)) {
      seenCombinations.current = [].concat(_toConsumableArray(seenCombinations.current), [filterIndex]);
      return true;
    } else {
      return false;
    }
  };
  useMarkSeenService({
    firstRequestCompleted: firstRequestCompleted
  });

  // Initial fetching
  useEffect(function () {
    if (fetchState === LoadingState.INITIAL) {
      fetchData();
    }
  }, [fetchState, fetchData]);
  useEffect(function () {
    var firstFilterView = isfirstFilterView(filters);
    fireNotificationFilterViewed(firstRender.current, firstFilterView);
    firstRender.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.readStateFilter, filters.categoryFilter, filters.productFilter]);
};